import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { apiRequest } from "./api";

// get Token
import useAuthToken from "../../Hooks/useAuthToken";

export const useCreateTopic = () => {
  const token = useAuthToken();

  const createTopic = async (credentials) => {
    if (!credentials) {
      throw new Error("Please provide credentials");
    }
    return apiRequest("post", "/api/topic", credentials, token);
  };

  return createTopic;
};

export const useGetTopic = () => {
  const token = useAuthToken();

  const getTopic = async () => {
    if (!token) {
      throw new Error("Token is missing");
    }

    return apiRequest("get", "/api/topic", null, token);
  };

  return getTopic;
};

// export const useGetCategoryById = (id) => {
//   const token = useAuthToken();

//   // Function to fetch category data
//   const getCategoryById = async () => {
//     if (!token) {
//       throw new Error("Token is missing");
//     }

//     const response = await apiRequest(
//       "get",
//       `/api/category/${id}`,
//       null,
//       token
//     );

//     return response;
//   };
//   return useQuery({
//     queryKey: ["single-category", id],
//     queryFn: getCategoryById,
//     enabled: !!id,
//   });
// };

export const useUpdateTopic = (id) => {
  const token = useAuthToken();

  const updateTopic = async (formData) => {
    if (!token) {
      throw new Error("Token is missing");
    }
    const response = await apiRequest(
      "patch",
      `/api/topic/${id}`,
      formData,
      token
    );

    return response;
  };

  return updateTopic;
};
